import React from "react";
import Home from "./pages/Home/Home";
import EventGallery from "./pages/Gallery/EventGallery/EventGallery";
import Donation from "./pages/Donate/Donate";
import IndividualEventGallery from "./components/IndividualEventGallery/IndividualEventGallery";
import ResourcesGen from "./pages/Resources/GeneralWebsites/GeneralWebsites";
import ResourcesAfr from "./pages/Resources/Africa/Africa";
import ResourcesLat from "./pages/Resources/Latin_America/Latin_America";
import ResourcesMid from "./pages/Resources/MiddleEast/MiddleEast";
import ResourcesPol from "./pages/Resources/MigrationPolicy/MigrationPolicy";
import CalendarEvents from "./pages/Volunteer/CalendarEvents/CalendarEvents";
import NewsletterGallery from "./pages/Gallery/NewsLetterGal/NewsLetterGal";
import IndividualNewsletter from "./components/IndividualNewletter/IndividualNewsletter";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { ErrorBoundary } from 'react-error-boundary';
import BranchCreation from "./pages/Volunteer/BranchCreation/BranchCreation";
import BranchRenwal from "./pages/Volunteer/BranchRenewal/BranchRenwal";
import Impact from "./pages/Impact/Impact";
import WhatWeDo from "./pages/Home/WhatWeDo";
import DonationCancelPage from "./components/Success_Fail_Donations/DonationCancelPage";
import DonationSuccessPage from "./components/Success_Fail_Donations/DonationSuccessPage";
import SFRReflections from "./pages/Publications/SFRReflections";
import Merch from "./pages/Merch/Merch";
import { CartProvider } from './pages/Merch/PreOrderCartContext.js';

const ErrorFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center p-8">
      <h2 className="text-2xl font-bold text-red-600">Something went wrong</h2>
      <button
        onClick={() => window.location.reload()}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
      >
        Try again
      </button>
    </div>
  </div>
);

function App() {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
        <CartProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about/what-we-do" element={<WhatWeDo />} />
              <Route exact path="/donate" element={<Donation />} />
              <Route exact path="/impact" element={<Impact />} />
              <Route path="/volunteer/calendar" element={<CalendarEvents />} />
              <Route path="/volunteer/branch-creation" element={<BranchCreation />} />
              <Route path="/volunteer/branch-renewal" element={<BranchRenwal />} />
              <Route path="/resources/general" element={<ResourcesGen />} />
              <Route path="/resources/africa" element={<ResourcesAfr />} />
              <Route path="/resources/latinamerica" element={<ResourcesLat />} />
              <Route path="/resources/middleeast" element={<ResourcesMid />} />
              <Route path="/resources/policy" element={<ResourcesPol />} />
              <Route exact path="/publications/sfr-reflections" element={<SFRReflections />} />
              <Route exact path="/gallery/events" element={<EventGallery />} />
              <Route
                path="/gallery/events/:eventName"
                element={<IndividualEventGallery />}
              />
              <Route path="/gallery/newsletters" element={<NewsletterGallery />} />
              <Route
                path="/gallery/newsletters/:newsletterName"
                element={<IndividualNewsletter />}
              />
              <Route path="/donation-success" element={<DonationSuccessPage />} />
              <Route path="/donation-cancel" element={<DonationCancelPage />} />
                <Route path="/merch" element={<Merch />} />
            </Routes>
          </Router>
        </CartProvider>
    </ErrorBoundary>
  );
}

export default App;
